import React, { useState } from "react";
import {
  Sidebar,
  Menu,
  MenuItem,
  SubMenu,
  useProSidebar,
} from "react-pro-sidebar";
import { SideBarData } from "./SideBarData";
import logoPropins from "../../img/LogoPropins.png";
import { useHistory } from "react-router-dom";
import {
  AppBar,
  Box,
  Button,
  IconButton,
  Toolbar,
  Typography,
  useMediaQuery,
  useTheme,
  Drawer
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useSelector } from "react-redux";

const SideMenu = () => {
  const history = useHistory();
  const { toggleSidebar, broken } = useProSidebar();
  const theme = useTheme();
  const isMobile = useMediaQuery('(max-width: 993px)');
  const shouldBreak = broken || isMobile;
  const [mobileOpen, setMobileOpen] = useState(false);

  const userData = useSelector((state) => state.app.itemUsuario);
  const tipoCuenta = userData && userData.tipoCuenta;

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
    if (broken) {
      toggleSidebar();
    }
  };

  const routeChange = (newPath) => {
    let path = newPath;
    history.push(path);
    if (shouldBreak) {
      setMobileOpen(false);
      if (broken) {
        toggleSidebar();
      }
    }
  };

  const sidebarContent = (
    <>
      <div className="logo">
        <img src={logoPropins} alt="Logo propins" className="logo"></img>
      </div>
      <Menu className="sideBarMenu">
        {SideBarData.map((val, key) => {
          if (val.accountType.includes(tipoCuenta)) {
            if (!val.submenu) {
              return (
                <MenuItem
                  style={{
                    fontSize: "20px",
                    marginBottom: "3px",
                  }}
                  id={
                    window.location.pathname.includes(val.link)
                      ? "active"
                      : "notActive"
                  }
                  key={key}
                  onClick={() => {
                    routeChange(val.link);
                  }}
                >
                  <div style={{ marginLeft: "20px" }}>{val.title}</div>
                </MenuItem>
              );
            } else {
              return (
                <SubMenu
                  key={key}
                  label={val.title}
                  style={{
                    fontSize: "20px",
                    marginBottom: "3px",
                    marginLeft: "20px",
                  }}
                >
                  {val.submenu.map((subItem, subKey) => {
                    if (subItem.accountType.includes(tipoCuenta)) {
                      return (
                        <MenuItem
                          style={{
                            fontSize: "17px",
                            marginBottom: "3px",
                          }}
                          className="sideBarElement"
                          id={
                            window.location.pathname.includes(subItem.link)
                              ? "active"
                              : "notActive"
                          }
                          key={subKey}
                          onClick={() => {
                            routeChange(subItem.link);
                          }}
                        >
                          <div style={{ marginLeft: "20px" }}>
                            {subItem.title}
                          </div>
                        </MenuItem>
                      );
                    }
                  })}
                </SubMenu>
              );
            }
          }
        })}
      </Menu>
    </>
  );

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', width: shouldBreak ? '100%' : 'auto' }}>
      {shouldBreak && (
        <AppBar position="static" sx={{ backgroundColor: "#00a62b", width: "100%" }}>
          <Toolbar>
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="menu"
              sx={{ mr: 2 }}
              onClick={handleDrawerToggle}
            >
              <MenuIcon />
            </IconButton>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1, textAlign: "left" }}>
              Propins
            </Typography>
          </Toolbar>
        </AppBar>
      )}

      {isMobile ? (
        <Drawer
          anchor="left"
          open={mobileOpen}
          onClose={handleDrawerToggle}
        >
          <div className="sidebarHeight" style={{ width: "250px" }}>
            <Sidebar breakPoint="0px" className="sidebarHeight" backgroundColor="#FBFBFB">
              {sidebarContent}
            </Sidebar>
          </div>
        </Drawer>
      ) : (
        <div className="sidebarHeight">
          <Sidebar breakPoint="993px" className="sidebarHeight" backgroundColor="#FBFBFB">
            {sidebarContent}
          </Sidebar>
        </div>
      )}
    </Box>
  );
};

export default SideMenu;
